import { ABILITY_SLOT } from "../bar/layout.ts";
import { SLOT_ICON_SIZE } from "./slot-icons.ts";

/**
 * Where a drawn icon sits in an ability slot's button (the stance button, the swap control): the slot's edge is
 * `ABILITY_SLOT.edge` on each side (a 1 pixel border, `SLOT_BORDER`, and a 1 pixel inner ring), which leaves the well
 * `ABILITY_SLOT.well` square, and the icon is centred in it, so none of its pixels reach the border or the ring.
 */

/**
 * The slot's border width in logical pixels, which `.ot-hud-ability` in `hud.css` draws (`tests/slot-art-css.test.ts` holds
 * it to the stylesheet); the rest of the edge is the inner ring.
 */
export const SLOT_BORDER = 1;

/**
 * A box in logical pixels from a slot's padding box: where the icon starts and its size.
 */
export interface SlotArt {
  readonly left: number;
  readonly top: number;
  readonly size: number;
}

/**
 * The slot's well: what the edge leaves inside the slot, as a size in logical pixels.
 *
 * @returns The well's width, which is also its height.
 */
export function slotInner(): number {
  return ABILITY_SLOT.size - 2 * ABILITY_SLOT.edge;
}

/**
 * The icon's box, centred in the slot's well and placed from the slot's padding box (an absolutely placed child is placed
 * from it).
 *
 * @returns The offset and size.
 * @example
 * slotArt();
 * // { left: 2, top: 2, size: 16 }
 */
export function slotArt(): SlotArt {
  const offset = Math.floor((ABILITY_SLOT.size - SLOT_ICON_SIZE) / 2) - SLOT_BORDER;
  return { left: offset, top: offset, size: SLOT_ICON_SIZE };
}
